import { PromoBannerType } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/bannerOrder";
import { useIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { getBrand } from "@faire/retailer-visitor-shared/serialized-data/getBrand";
import { specialHolidayNet90Active } from "@faire/retailer-visitor-shared/settings/getSettingSpecialHolidayNet90";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { getLoggedOutPromoBanners } from "@faire/retailer-visitor-shared/stores/ui/getLoggedOutPromoBanners";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import React from "react";

export const useLoggedOutPromoBanners = (): PromoBannerType[] => {
  const location = getLocationOrThrow();
  const isBrandPreview = useIsBrandPreview();
  const brand = getBrand();
  const { isPreshowOrLive: isFaireMarketPreshowOrLive } = useMarketStore();

  const isSpecialHolidayNet90Active = specialHolidayNet90Active();

  const promoBanners = React.useMemo(
    () =>
      getLoggedOutPromoBanners({
        location,
        isBrandPreviewAndBrandIsInactive:
          isBrandPreview && !brand?.first_active_at,
        isFaireMarketPreshowOrLive,
        isSpecialHolidayNet90Active,
      }),
    [
      location,
      isBrandPreview,
      brand,
      isFaireMarketPreshowOrLive,
      isSpecialHolidayNet90Active,
    ]
  );
  return promoBanners;
};
